import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Archive16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M1.44463 2.45138C1.72933 2.16237 2.11545 2 2.51807 2H13.4819C13.8845 2 14.2707 2.16237 14.5554 2.45138C14.8401 2.74039 15 3.13237 15 3.5411V5.25342C15 5.6317 14.6979 5.93836 14.3253 5.93836H1.6747C1.30207 5.93836 1 5.6317 1 5.25342V3.5411C1 3.13237 1.15994 2.74039 1.44463 2.45138ZM2.51807 3.36986C2.47334 3.36986 2.43043 3.3879 2.3988 3.42002C2.36717 3.45213 2.3494 3.49568 2.3494 3.5411V4.56849H13.6506V3.5411C13.6506 3.49568 13.6328 3.45213 13.6012 3.42002C13.5696 3.3879 13.5267 3.36986 13.4819 3.36986H2.51807ZM2.51807 6.28082C2.8907 6.28082 3.19277 6.58748 3.19277 6.96575V12.1027C3.19277 12.3752 3.2994 12.6365 3.48919 12.8292C3.67899 13.0219 3.93641 13.1301 4.20482 13.1301H11.7952C12.0636 13.1301 12.321 13.0219 12.5108 12.8292C12.7006 12.6365 12.8072 12.3752 12.8072 12.1027V6.96575C12.8072 6.58748 13.1093 6.28082 13.4819 6.28082C13.8546 6.28082 14.1566 6.58748 14.1566 6.96575V12.1027C14.1566 12.7385 13.9078 13.3483 13.465 13.7979C13.0221 14.2474 12.4215 14.5 11.7952 14.5H4.20482C3.57853 14.5 2.97788 14.2474 2.53503 13.7979C2.09217 13.3483 1.84337 12.7385 1.84337 12.1027V6.96575C1.84337 6.58748 2.14545 6.28082 2.51807 6.28082Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M5.875 8C5.875 7.65482 6.15482 7.375 6.5 7.375H9.5C9.84518 7.375 10.125 7.65482 10.125 8C10.125 8.34518 9.84518 8.625 9.5 8.625H6.5C6.15482 8.625 5.875 8.34518 5.875 8Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
